import React from 'react';
import AnimatedSection from '../components/blocks/AnimatedSection';

const Archives = () => {
    return (
        <div className="min-h-screen bg-gray-50 py-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="text-center mt-8 mb-12">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">Archives</h1>
                    <p className="text-xl text-gray-600 max-w-5xl mx-auto text-center">
                        Explore our historical records, past events, and legacy content that has shaped our organization's journey.
                    </p>
                </div>

                {/* TRACES 2025 Section */}
                <AnimatedSection
                    className="mb-16"
                    heading={
                        <div className="text-center mb-8">
                            <img src="/asset/images/traces-logo.png" alt="TRACES Logo" className="h-16 w-auto mx-auto mb-4" />
                            <h2 className="text-3xl font-semibold text-gray-900">TRACES 2025</h2>
                        </div>
                    }
                >
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="mb-8">
                            <h3 className="text-2xl font-semibold text-gray-900 mb-4">Conference Overview</h3>
                            <p className="text-lg text-gray-700 leading-relaxed mb-6 text-justify">
                                The Transdisciplinary Academic Conference for Emerging Scholars (TRACES) 2025 is an undergraduate conference held on 28.06.2025 at the University of Hong Kong (HKU) by a group of HKU undergraduates to promote transdisciplinary research.
                            </p>
                        </div>

                        {/*<div className="grid md:grid-cols-2 gap-8 mb-8">
                            <div>
                                <h4 className="text-xl font-semibold text-gray-900 mb-4">Conference Highlights</h4>
                                <ul className="space-y-2 text-gray-700">
                                    <li>• 500+ attendees from 25 countries</li>
                                    <li>• 75+ presentations and workshops</li>
                                    <li>• 15 keynote speakers from leading institutions</li>
                                    <li>• 3 days of intensive learning and networking</li>
                                    <li>• Virtual and in-person hybrid format</li>
                                </ul>
                            </div>
                            <div>
                                <h4 className="text-xl font-semibold text-gray-900 mb-4">Key Themes</h4>
                                <ul className="space-y-2 text-gray-700">
                                    <li>• Artificial Intelligence in Education</li>
                                    <li>• Digital Learning Transformation</li>
                                    <li>• Educational Leadership in Crisis</li>
                                    <li>• Sustainable Technology Solutions</li>
                                    <li>• Global Collaboration in Education</li>
                                </ul>
                            </div>
                        </div>*/}

                        {/*<div className="mb-8">
                            <h4 className="text-xl font-semibold text-gray-900 mb-4">Featured Speakers</h4>
                            <div className="grid md:grid-cols-3 gap-6">
                                <div className="text-center p-4 border rounded-lg">
                                    <div className="w-16 h-16 bg-blue-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                                        <span className="text-blue-600 font-semibold">DR</span>
                                    </div>
                                    <h5 className="font-semibold text-gray-900">Dr. Rebecca Davis</h5>
                                    <p className="text-gray-600 text-sm">MIT Technology Review</p>
                                    <p className="text-gray-700 text-sm mt-2">"The Future of AI in Educational Assessment"</p>
                                </div>
                                <div className="text-center p-4 border rounded-lg">
                                    <div className="w-16 h-16 bg-green-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                                        <span className="text-green-600 font-semibold">PM</span>
                                    </div>
                                    <h5 className="font-semibold text-gray-900">Prof. Michael Chen</h5>
                                    <p className="text-gray-600 text-sm">Stanford University</p>
                                    <p className="text-gray-700 text-sm mt-2">"Digital Transformation in Higher Education"</p>
                                </div>
                                <div className="text-center p-4 border rounded-lg">
                                    <div className="w-16 h-16 bg-purple-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                                        <span className="text-purple-600 font-semibold">SA</span>
                                    </div>
                                    <h5 className="font-semibold text-gray-900">Dr. Sarah Ahmed</h5>
                                    <p className="text-gray-600 text-sm">UNESCO</p>
                                    <p className="text-gray-700 text-sm mt-2">"Global Education Policy and Technology"</p>
                                </div>
                            </div>
                        </div>*/}

                        {/* Keynote Speaker - Commented Out */}
                        {/*
                        <div className="mb-8">
                            <h4 className="text-xl font-semibold text-gray-900 mb-4">Keynote Speaker</h4>
                            <div className="grid md:grid-cols-3 gap-8 items-center">
                                <div className="md:col-span-1">
                                    <div className="w-full aspect-square rounded-2xl overflow-hidden shadow-lg">
                                        <img src="/asset/images/Archives/TRACES 2025/javier-cha.jpg" alt="Professor Javier Cha" className="w-full h-full object-cover" />
                                    </div>
                                </div>
                                <div className="md:col-span-2">
                                    <h5 className="text-xl md:text-2xl font-semibold text-gray-900">Professor Javier Cha</h5>
                                    <p className="text-gray-600">Assistant Professor, The University of Hong Kong</p>
                                    <p className="mt-4 text-gray-700 leading-relaxed">
                                        As the keynote speaker for TRACES, Professor Cha exemplifies the conference's commitment to blending humanities, technology, and sustainability. His work aligns with the theme of fostering innovative, transdisciplinary research, inspiring students to explore the future of academic inquiry in a digitally transformed world.
                                    </p>
                                </div>
                            </div>
                        </div>
                        */}

                        <div className="mb-4">
                            <h4 className="text-xl font-semibold text-gray-900 mb-4">Conference Materials</h4>
                            <div className="grid md:grid-cols-2 gap-6">
                                <div className="p-4 border rounded-lg">
                                    <a
                                        href="https://play.google.com/store/books/details?pcampaignid=books_read_action&id=w9RlEQAAQBAJ"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="block w-full bg-gray-100 rounded-md overflow-hidden mb-3 group relative cursor-pointer"
                                    >
                                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 z-10"></div>
                                        <img
                                            src="/asset/images/Archives/TRACES 2025/Book of Abstracts.avif"
                                            alt="Book of Abstracts thumbnail"
                                            className="w-full h-auto object-contain group-hover:scale-110 transition-transform duration-300"
                                            loading="lazy"
                                        />
                                    </a>
                                    <h5 className="font-semibold text-gray-900 mb-1.5">Book of Abstracts</h5>
                                    <p className="text-gray-600 text-sm mb-4">Complete collection of all presentation abstracts from TRACES 2025</p>
                                    <div className="flex gap-2">
                                        <a
                                            href="https://zenodo.org/records/17118808"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex-1 px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-blue-400 hover:text-blue-600 transition text-center"
                                        >
                                            Read on Zenodo
                                        </a>
                                        <a
                                            href="https://play.google.com/store/books/details?pcampaignid=books_read_action&id=w9RlEQAAQBAJ"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex-1 px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-green-400 hover:text-green-600 transition text-center"
                                        >
                                            Read on Google Books
                                        </a>
                                    </div>
                                </div>
                                <div className="p-4 border rounded-lg">
                                    <a
                                        href="https://play.google.com/store/books/details/Tse_Sheung_Hei_Transdisciplinary_Academic_Conferen?id=LQaJEQAAQBAJ"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="block w-full bg-gray-100 rounded-md overflow-hidden mb-3 group relative cursor-pointer"
                                    >
                                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 z-10"></div>
                                        <img
                                            src="/asset/images/Archives/TRACES 2025/Conference Proceedings.avif"
                                            alt="Conference Proceedings thumbnail"
                                            className="w-full h-auto object-contain group-hover:scale-110 transition-transform duration-300"
                                            loading="lazy"
                                        />
                                    </a>
                                    <h5 className="font-semibold text-gray-900 mb-1.5">Conference Proceedings</h5>
                                    <p className="text-gray-600 text-sm mb-4">Complete collection of all presentations and papers from TRACES 2025</p>
                                    <div className="flex gap-2">
                                        <a
                                            href="https://zenodo.org/records/17200123"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex-1 px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-blue-400 hover:text-blue-600 transition text-center"
                                        >
                                            Read on Zenodo
                                        </a>
                                        <a
                                            href="https://play.google.com/store/books/details/Tse_Sheung_Hei_Transdisciplinary_Academic_Conferen?id=LQaJEQAAQBAJ"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex-1 px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-green-400 hover:text-green-600 transition text-center"
                                        >
                                            Read on Google Books
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-6">
                                <a
                                    href="/asset/documents/TRACES%202025%20Annual%20Report.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block w-full md:w-auto mx-auto px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-orange-400 hover:text-orange-600 transition text-center"
                                >
                                    Download TRACES 2025 Annual Report
                                </a>
                            </div>
                        </div>

                        {/*<div>
                            <h4 className="text-xl font-semibold text-gray-900 mb-4">Conference Impact</h4>
                            <div className="grid md:grid-cols-4 gap-6">
                                <div className="text-center p-4 border rounded-lg">
                                    <div className="text-3xl font-bold text-blue-600 mb-2">95%</div>
                                    <p className="text-gray-600 text-sm">Satisfaction Rate</p>
                                </div>
                                <div className="text-center p-4 border rounded-lg">
                                    <div className="text-3xl font-bold text-green-600 mb-2">150+</div>
                                    <p className="text-gray-600 text-sm">New Collaborations</p>
                                </div>
                                <div className="text-center p-4 border rounded-lg">
                                    <div className="text-3xl font-bold text-purple-600 mb-2">25</div>
                                    <p className="text-gray-600 text-sm">Research Projects Initiated</p>
                                </div>
                                <div className="text-center p-4 border rounded-lg">
                                    <div className="text-3xl font-bold text-orange-600 mb-2">$2M+</div>
                                    <p className="text-gray-600 text-sm">Funding Generated</p>
                                </div>
                            </div>
                        </div>*/}
                    </div>

                    {/* TRACES 2025 Conclusion Announcement */}
                    <div id="traces-conclusion" className="bg-yellow-50 border-2 border-yellow-400 rounded-lg p-6 md:p-8 mt-8">
                        <div className="space-y-4 text-gray-900 text-justify">
                            <p className="text-lg font-semibold text-justify">
                                TRACES 2025 has formally concluded with the distribution of our Conference Proceedings. As we end our journey, let us reflect and clarify our position as an initiative.
                            </p>
                            <p className="text-justify">
                                TRACES 2025 is, and always has been, a student-led initiative; nothing more, nothing less. The term "Executive Committee" within TRACES 2025 was never a legal body nor registered as a society. While we sincerely thank everybody, within and beyond the committee, for their contribution, the term simply referred to an informal group of students collaborating on the conference. Any implication of formal authority or legal standing behind that label is incorrect and rescinded. We encourage everyone to make the most of their educational journey and life beyond.
                            </p>
                            <p className="font-semibold text-justify">Before we say our goodbyes, we would like to provide a few closing remarks.</p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li>All TRACES 2025 partnerships and advisory bodies conclude with this announcement.</li>
                                <li>The website, <a href="https://www.traceshk.com/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 underline">https://www.traceshk.com/</a> is operated separately and does not reflect the views, intentions, or affiliations of the TRACES 2025 organisers, contributors, or supporting institutions.</li>
                                <li>Our Instagram (@traceshk2025) is now a read-only archive. No further updates or comments will be posted.</li>
                                <li>The email traceshk@gmail.com remains open for any final inquiries. All other social or messaging channels are closed effective immediately.</li>
                            </ul>
                            <p className="text-lg font-semibold text-justify">
                                We sincerely thank you for your support throughout TRACES 2025!
                            </p>
                        </div>
                    </div>
                </AnimatedSection>

                {/* Historical Timeline
                <section className="mb-16">
                    <h2 className="text-3xl font-semibold text-gray-900 mb-8">Historical Timeline</h2>
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="space-y-8">
                            <div className="flex items-start space-x-6">
                                <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                                    <span className="text-blue-600 font-semibold">2012</span>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Foundation of TITAN</h3>
                                    <p className="text-gray-700">
                                        TITAN was established with the vision of providing comprehensive career guidance to students worldwide.
                                        The initial platform focused on university application support and career planning.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start space-x-6">
                                <div className="flex-shrink-0 w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                                    <span className="text-green-600 font-semibold">2015</span>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Launch of CORTEX</h3>
                                    <p className="text-gray-700">
                                        CORTEX was introduced as a collaborative research platform, enabling researchers and students
                                        to connect and work together on innovative projects across institutions.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start space-x-6">
                                <div className="flex-shrink-0 w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
                                    <span className="text-purple-600 font-semibold">2018</span>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900 mb-2">JELTR Journal Launch</h3>
                                    <p className="text-gray-700">
                                        The Journal of Educational Leadership and Technology Research was launched, providing a platform
                                        for high-quality academic publishing in education and technology.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start space-x-6">
                                <div className="flex-shrink-0 w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                                    <span className="text-orange-600 font-semibold">2020</span>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Digital Transformation</h3>
                                    <p className="text-gray-700">
                                        In response to the global pandemic, we accelerated our digital transformation, introducing
                                        virtual events, online collaboration tools, and enhanced remote learning support.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start space-x-6">
                                <div className="flex-shrink-0 w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                                    <span className="text-red-600 font-semibold">2023</span>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900 mb-2">AI Integration</h3>
                                    <p className="text-gray-700">
                                        We integrated artificial intelligence into our platform, providing personalized recommendations,
                                        automated career matching, and intelligent research assistance.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start space-x-6">
                                <div className="flex-shrink-0 w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center">
                                    <span className="text-indigo-600 font-semibold">2025</span>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900 mb-2">TRACES Conference</h3>
                                    <p className="text-gray-700">
                                        Our largest conference to date, TRACES 2025, brought together the global education community
                                        to explore the future of technology in education and research collaboration.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}

                {/* Past Events Archive
                <section className="mb-16">
                    <h2 className="text-3xl font-semibold text-gray-900 mb-8">Past Events Archive</h2>
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="space-y-6">
                            <div className="border-l-4 border-blue-500 pl-6">
                                <h3 className="text-xl font-semibold text-gray-900 mb-2">Annual Research Symposium 2024</h3>
                                <p className="text-gray-600 mb-2">March 15-17, 2024</p>
                                <p className="text-gray-700 mb-3">Featured 50+ research presentations and 10 keynote speakers</p>
                                <button className="text-blue-600 hover:text-blue-800 text-sm">View Archive</button>
                            </div>

                            <div className="border-l-4 border-green-500 pl-6">
                                <h3 className="text-xl font-semibold text-gray-900 mb-2">International Collaboration Summit 2024</h3>
                                <p className="text-gray-600 mb-2">January 20-22, 2024</p>
                                <p className="text-gray-700 mb-3">Brought together 200+ international partners and collaborators</p>
                                <button className="text-blue-600 hover:text-blue-800 text-sm">View Archive</button>
                            </div>

                            <div className="border-l-4 border-purple-500 pl-6">
                                <h3 className="text-xl font-semibold text-gray-900 mb-2">Student Innovation Showcase 2023</h3>
                                <p className="text-gray-600 mb-2">November 10-12, 2023</p>
                                <p className="text-gray-700 mb-3">Celebrated student achievements and innovative projects</p>
                                <button className="text-blue-600 hover:text-blue-800 text-sm">View Archive</button>
                            </div>

                            <div className="border-l-4 border-orange-500 pl-6">
                                <h3 className="text-xl font-semibold text-gray-900 mb-2">Technology in Education Conference 2023</h3>
                                <p className="text-gray-600 mb-2">September 5-7, 2023</p>
                                <p className="text-gray-700 mb-3">Explored emerging technologies and their impact on education</p>
                                <button className="text-blue-600 hover:text-blue-800 text-sm">View Archive</button>
                            </div>

                            <div className="border-l-4 border-red-500 pl-6">
                                <h3 className="text-xl font-semibold text-gray-900 mb-2">Global Education Forum 2023</h3>
                                <p className="text-gray-600 mb-2">June 15-17, 2023</p>
                                <p className="text-gray-700 mb-3">Addressed global challenges in education and policy</p>
                                <button className="text-blue-600 hover:text-blue-800 text-sm">View Archive</button>
                            </div>
                        </div>
                    </div>
                </section> */}

                {/* Legacy Content
                <section className="mb-16">
                    <h2 className="text-3xl font-semibold text-gray-900 mb-8">Legacy Content</h2>
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="grid md:grid-cols-2 gap-8">
                            <div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">Historical Publications</h3>
                                <div className="space-y-4">
                                    <div className="p-4 border rounded-lg">
                                        <h4 className="font-semibold text-gray-900">TITAN Annual Reports</h4>
                                        <p className="text-gray-600 text-sm mb-2">Complete collection from 2012-2024</p>
                                        <button className="text-blue-600 hover:text-blue-800 text-sm">Browse Reports</button>
                                    </div>
                                    <div className="p-4 border rounded-lg">
                                        <h4 className="font-semibold text-gray-900">Research White Papers</h4>
                                        <p className="text-gray-600 text-sm mb-2">Influential research publications</p>
                                        <button className="text-blue-600 hover:text-blue-800 text-sm">View Papers</button>
                                    </div>
                                    <div className="p-4 border rounded-lg">
                                        <h4 className="font-semibold text-gray-900">Policy Briefs</h4>
                                        <p className="text-gray-600 text-sm mb-2">Educational policy recommendations</p>
                                        <button className="text-blue-600 hover:text-blue-800 text-sm">Read Briefs</button>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">Media Archive</h3>
                                <div className="space-y-4">
                                    <div className="p-4 border rounded-lg">
                                        <h4 className="font-semibold text-gray-900">Video Library</h4>
                                        <p className="text-gray-600 text-sm mb-2">Recorded presentations and interviews</p>
                                        <button className="text-blue-600 hover:text-blue-800 text-sm">Watch Videos</button>
                                    </div>
                                    <div className="p-4 border rounded-lg">
                                        <h4 className="font-semibold text-gray-900">Photo Gallery</h4>
                                        <p className="text-gray-600 text-sm mb-2">Historical photos from events and activities</p>
                                        <button className="text-blue-600 hover:text-blue-800 text-sm">View Gallery</button>
                                    </div>
                                    <div className="p-4 border rounded-lg">
                                        <h4 className="font-semibold text-gray-900">Podcast Archive</h4>
                                        <p className="text-gray-600 text-sm mb-2">Educational podcasts and interviews</p>
                                        <button className="text-blue-600 hover:text-blue-800 text-sm">Listen Now</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}

                {/* Digital Preservation    
                <section className="mb-16">
                    <h2 className="text-3xl font-semibold text-gray-900 mb-8">Digital Preservation</h2>
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="text-center">
                            <h3 className="text-2xl font-semibold text-gray-900 mb-4">Preserving Our Digital Heritage</h3>
                            <p className="text-lg text-gray-700 leading-relaxed mb-8">
                                We are committed to preserving our digital heritage for future generations. Our archives are maintained
                                using industry-standard preservation techniques and are regularly migrated to ensure long-term accessibility.
                            </p>
                            <div className="grid md:grid-cols-3 gap-6">
                                <div className="text-center p-4">
                                    <div className="w-16 h-16 bg-blue-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                                        <span className="text-2xl">💾</span>
                                    </div>
                                    <h4 className="font-semibold text-gray-900 mb-2">Digital Storage</h4>
                                    <p className="text-gray-600 text-sm">Secure, redundant storage systems</p>
                                </div>
                                <div className="text-center p-4">
                                    <div className="w-16 h-16 bg-green-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                                        <span className="text-2xl">🔄</span>
                                    </div>
                                    <h4 className="font-semibold text-gray-900 mb-2">Format Migration</h4>
                                    <p className="text-gray-600 text-sm">Regular format updates and migrations</p>
                                </div>
                                <div className="text-center p-4">
                                    <div className="w-16 h-16 bg-purple-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                                        <span className="text-2xl">🔍</span>
                                    </div>
                                    <h4 className="font-semibold text-gray-900 mb-2">Metadata Standards</h4>
                                    <p className="text-gray-600 text-sm">Comprehensive metadata for searchability</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
            </div>
        </div>
    );
};

export default Archives;
